module.exports = __webpack_public_path__ + "static/media/BS.b9c8e9e5.png";